export const errorOnStatus = (
    status: number,
    callback: (value: boolean) => void,
) => {
    if (status !== 200) {
        callback(true);
    }
};
